import React from 'react';
import styles from './styles/ButtonCombo.module.scss';
import Back from './Back';
import Button from './Button';

interface IProps {
  className?: string;
  backProps?: React.ComponentProps<typeof Back>;
  submitProps?: React.ComponentProps<typeof Button>;
}

// Component that renders Back and Submit buttons
const ButtonCombo = ({ className, backProps, submitProps }: IProps) => {
  return (
    <div className={classnames(styles.container, className)}>
      {backProps && (
        <Back
          {...backProps}
          className={classnames(styles.back, backProps?.className)}
        />
      )}
      <Button
        {...submitProps}
        className={classnames(styles.submit, submitProps?.className)}
      />
    </div>
  );
};

export default ButtonCombo;
